import { gql } from '@apollo/client'

export const BRAND_EXECUTION_FRAGMENT = gql`
  fragment BrandExecution on BrandExecution {
    id
    name
    displayShare
    sharedDisplayShare
    compDisplayShare
    changeInDisplayShare
    sovi
    soviChange
    numAuditedStores
  }
`
